export default "__VITE_ASSET__Bu6WU3c___"